import { AxleAutocompleteField } from '../../../components/formFields/AxleAutocompleteField';
import {
    AxleDialog,
    AxleDialogActions,
    AxleDialogContent,
    AxleDialogPrimaryButton,
} from '../../../components/layout/AxleDialog';
import {
    useCreateConnection,
    useCreateConnectionOptions,
} from '../../../fetching/api/supplyAndDemandConnections';
import { useInputState, useJointInputState } from '../../../utils/inputState';
import { ReturnComponent } from '../../../utils/reactTypes';

const CreateConnectionDialogContents = ({ close }: { close: () => void }): ReturnComponent => {
    const { fromOrgs, toOrgs } = useCreateConnectionOptions();
    const createConnection = useCreateConnection();

    const fromOrgIdState = useInputState<string>('', { required: true });
    const toOrgIdState = useInputState<string>('', { required: true });

    const { checkValid } = useJointInputState([fromOrgIdState, toOrgIdState]);

    return (
        <>
            <AxleDialogContent>
                <AxleAutocompleteField
                    label={'From Organization'}
                    inputState={fromOrgIdState}
                    options={fromOrgs}
                    optionToValue={(org) => org.uuid}
                    optionToLabel={(org) => org.name}
                />
                <AxleAutocompleteField
                    label={'To Organization'}
                    inputState={toOrgIdState}
                    options={toOrgs}
                    optionToValue={(org) => org.uuid}
                    optionToLabel={(org) => org.name}
                />
            </AxleDialogContent>
            <AxleDialogActions>
                <AxleDialogPrimaryButton
                    label={'Create'}
                    onClick={() => {
                        if (!checkValid()) {
                            return;
                        }
                        void createConnection(
                            {
                                fromOrgId: fromOrgIdState.value,
                                toOrgId: toOrgIdState.value,
                            },
                            {
                                onSuccess: close,
                            },
                        );
                    }}
                />
            </AxleDialogActions>
        </>
    );
};

export const CreateConnectionDialog = ({
    isOpen,
    close,
}: {
    isOpen: boolean;
    close: () => void;
}): ReturnComponent => {
    return (
        <AxleDialog
            dataTestId='create-connection-dialog'
            isOpen={isOpen}
            close={close}
            title={'Create Connection'}
        >
            <CreateConnectionDialogContents close={close} />
        </AxleDialog>
    );
};
